import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useSocket } from '../context/SocketContext';

const ConnectivityManager = ({ children }) => {
    const [showPopup, setShowPopup] = useState(false);
    const { user } = useAuth();
    const { socket } = useSocket();

    // Ensure user joins their personal room for direct calls
    useEffect(() => {
        if (socket && user) {
            const userId = (user._id || user.id).toString();
            socket.emit('join_room', userId);
            console.log("🔌 Socket Joined Personal Room:", userId);
        }
    }, [socket, user]);

    useEffect(() => {
        const handleOnline = () => {
            setShowPopup(false);
        };
        const handleOffline = () => {
            setShowPopup(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <>
            {showPopup && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fadeIn">
                    <div className="bg-gray-900 border-2 border-red-500 rounded-3xl p-8 max-w-sm w-full text-center shadow-2xl shadow-red-500/20 transform animate-scaleUp">
                        <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 0a5 5 0 010-7.072m0 0l2.829 2.829m-4.243 4.243a9 9 0 010-12.728m0 0l2.829 2.829" />
                            </svg>
                        </div>
                        <h2 className="text-2xl font-bold text-light mb-2">No Internet</h2>
                        <p className="text-gray-400 mb-6">Please check your connection to continue using Dr. Vivara.</p>
                        <button
                            onClick={() => window.location.reload()}
                            className="w-full bg-red-500 text-white font-bold py-4 rounded-2xl hover:bg-red-600 transition-colors shadow-lg shadow-red-500/30"
                        >
                            Retry Connection
                        </button>
                    </div>
                </div>
            )}
            {children}
        </>
    );
};

export default ConnectivityManager;
